import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { setKeypadAction, clearKeypadAction } from "../../../../redux/answeringQuestions/keypad";

const Inputer = ( props ) => {

  const deviceInfo = useSelector( state => state.deviceInfo );

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const setKeypad = payload => { dispatch( setKeypadAction( payload ) ) };
  const clearKeypad = () => { dispatch( clearKeypadAction() ) };

  useEffect( () => {

    setAnsweringQuestions( { keypadType : TYPE.KEYPAD.NOTE } );
    return () => {
      setTimeout( clearKeypad );
    };
  }, [] );

  useEffect( () => {
    if ( TYPE.DEVICE.PAD === deviceInfo.type ) {
      const orientation = window.matchMedia( '( orientation:portrait )' );
      orientation.addEventListener( 'change', changeOrientation );
      changeOrientation( orientation );
      return () => {
        orientation.removeEventListener( 'change', changeOrientation );
      };
    }
  }, [ deviceInfo.type ] );

  const changeOrientation = ( event ) => {
    setKeypad( { orientation : event.matches ? TYPE.ORIENTATION.PORTRAIT : TYPE.ORIENTATION.LANDSCAPE } );
  };

  return props.children || null;

};

export default Inputer;
